import { Helmet } from 'react-helmet-async'; 
import { Button,  Container, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { Field, Form, Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { addDoc, collection } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../../firebase';

function NEwProjects() {

    const [loading, setloading] = useState(false)
    const provinces = [
        "Central",
        "Copperbelt",
        "Eastern",
        "Luapula",
        "Lusaka",
        "Muchinga",
        "Northern",
        "North-Western",
        "Southern",
        "Western"
      ];
const navigate = useNavigate()
const initialValues = {      
    name: "",
    description : "",
    province : "",
    start : ""
  };

  const validationSchema = Yup.object().shape({
       name: Yup.string().required("Name is required"),
       description: Yup.string().required("Description is required"),
       province: Yup.string().required("province is required"),
       start: Yup.string().required("Start Date is required"),
  });  

  return (
    <>
    <Helmet>
      <title> New Project</title>
    </Helmet>

    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          New Project
        </Typography>         
      </Stack> 

      <Formik  initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values) => {
                            setloading(true)
                        console.log(values);
                        const docRef = await addDoc(collection(db, "projects"),  {...values, userId : auth.currentUser.uid, createdAt : Date.now()});                      
                            console.log("Document written with ID: ", docRef.id);
                            setloading(false)
                            navigate(-1)
                                    }}
                    >
                        {(formik) => (
                        <Form>
                        <Stack spacing={2}> 
                            <Field
                            
                            as={TextField}
                            type="text"
                            name="name" 
                            label="Project Name"
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                            />  
                            <Field
                             
                            as={TextField}
                            name="description"              
                            label="Description"
                            error={formik.touched.description && Boolean(formik.errors.description)}
                            helperText={formik.touched.description && formik.errors.description}
                            />                            
                  
                     <Field
                             
                             as={TextField}
                             type="date"
                             name="start"              
                             label="Start Date"
                             error={formik.touched.start && Boolean(formik.errors.start)}
                             helperText={formik.touched.start && formik.errors.start}
                             />                            
                
                     <Field
                             
                            as={TextField}
                            name="province"
                            select
                            label="Province"
                            error={formik.touched.province && Boolean(formik.errors.province)}
                            helperText={formik.touched.province && formik.errors.province}
                            > 
                            {provinces.map((c, index)=>(
                            <MenuItem value={c} key={index}>{c}</MenuItem>
                    ))}
                            </Field>  
                                {loading ? <Typography>Saving project</Typography> : 
                                <LoadingButton loading={loading} variant='contained'   size={"large"} color="success" disabled={!formik.isValid} type='submit'>Save Profile</LoadingButton>   }
                                </Stack>
                            </Form>
                        )}
                            </Formik>

    </Container>
  </>
  )
}

export default NEwProjects